import { Formik, useFormik } from "formik";
import { useEffect, useState } from "react";
import { Button, Checkbox, Dialog, Grid, TextField } from "src/components";
import ReportMailRequest from "src/models/Print/ReportMailRequest";
import * as yup from "yup";
import Autocomplete from "src/components/Autocomplete";
import GnlKullaniciAyarDTO from "src/models/Base/Auth/GnlKullaniciAyarDTO";
import { helper } from "src/utils/helper";
import kullaniciAyarService from "src/services/Genel/kullanici.ayar.service";
import { useAppDispatch, useAppSelector } from "src/store";
import KararDestekSlice from "src/store/Slices/KararDestekSlices";
import { useLazyExportPrintMailMessageQuery } from "src/services/Printer/PrinterApi";
import DialogTitle from "src/components/DialogTitle";
import DialogContent from "src/components/DialogContent";
import DialogActions from "src/components/DialogActions";

const ButtonPrintMail = (props): JSX.Element => {
    const [options, setOptions] = useState<Array<GnlKullaniciAyarDTO>>(new Array<GnlKullaniciAyarDTO>())
    const kararDestek = useAppSelector(s => s.kararDestek)
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!kararDestek.mailOpen)
            return;
        kullaniciAyarService.find({
            filters: {
                groupOperator: "and",
                predicates: [
                    {
                        fieldName: "kullaniciId",
                        operator: "=",
                        value1: 1
                    },
                    {
                        fieldName: "tip",
                        operator: "=",
                        value1: 1
                    }
                ]
            },
        }).then(res => {
            setOptions(res.data)
        })
    }, [kararDestek.mailOpen])

    const [exportMail, exportMailState] = useLazyExportPrintMailMessageQuery()
    const fp = useFormik({
        validationSchema: yup.object({
            to: yup.array().required().required("To alanı boş geçilemez!..."),
            subject: yup.string().required("Konu alanı boş geçilemez!...")
        }),
        enableReinitialize: true,
        initialValues: new ReportMailRequest(),
        validateOnChange: false,
        onSubmit: (values) => {
            exportMail({
                ...values,
                reportEntry: kararDestek.reportGuid,
            })
                .unwrap()
                .then(res => {
                    dispatch(KararDestekSlice.actions.setState({
                        ...kararDestek,
                        mailOpen: false
                    }))
                })
                .catch(e => e)
        }
    })
    return (
        <Dialog open={kararDestek.mailOpen}>
            <DialogTitle>{kararDestek.raporSorgu.raporAdi + " Mail Gönderimi"}</DialogTitle>
            <DialogContent>
                <Grid container maxWidth={"md"} >
                    <Grid item md={12}>
                        <Autocomplete
                            fullWidth
                            options={options}
                            value={fp.values.to || []}
                            multiple
                            freeSolo={false}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            getOptionLabel={(option) => option?.ayar}
                            sx={{
                                paddingTop: 2
                            }}
                            filterOptions={(option, state) => {
                                var filtered: GnlKullaniciAyarDTO[] = [];
                                if (!state.inputValue)
                                    return filtered;
                                var filter = option.filter(f => helper.UpperCaseAsc(f.ayar).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
                                if (filter.length == 0) {
                                    filtered.push({
                                        ayar: "Ekle " + state.inputValue,
                                        kullaniciId: 1,
                                        tip: 1
                                    })
                                }
                                else filtered = filter;
                                return filtered;
                            }}
                            onChange={(event, newValues) => {
                                for (let i in newValues) {
                                    if (!newValues[i].id) {
                                        newValues[i].ayar = newValues[i].ayar?.replace("Ekle ", "")
                                    }
                                }
                                fp.setValues({
                                    ...fp.values,
                                    to: newValues
                                })
                            }}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}
                                        label="Kime"
                                        required
                                        error={Boolean(fp.errors.to)}
                                        helperText={fp.errors.to as string}
                                    >

                                    </TextField>
                                )
                            }} />
                    </Grid>
                    <Grid item md={12}>
                        <Autocomplete
                            options={options}
                            value={fp.values.cc || []}
                            multiple
                            freeSolo={false}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            getOptionLabel={(option) => option?.ayar}
                            filterOptions={(option, state) => {
                                var filtered: GnlKullaniciAyarDTO[] = [];
                                if (!state.inputValue)
                                    return filtered;
                                var filter = option.filter(f => helper.UpperCaseAsc(f.ayar).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1)
                                if (filter.length == 0) {
                                    filtered.push({
                                        ayar: "Ekle " + state.inputValue,
                                        kullaniciId: 1,
                                        tip: 1
                                    })
                                }
                                else filtered = filter;
                                return filtered;
                            }}
                            onChange={(event, newValues) => {
                                fp.setValues({
                                    ...fp.values,
                                    cc: newValues
                                })
                            }}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}
                                        label="Bilgi"
                                    >

                                    </TextField>
                                )
                            }} />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name={"subject"}
                            value={fp.values.subject || ""}
                            onChange={fp.handleChange}
                            helperText={fp.errors.subject}
                            error={Boolean(fp.errors.subject)}
                            label="Konu"
                            required
                        >
                        </TextField>
                    </Grid>
                    <Grid item md={12}>
                        <Checkbox
                            label={"Ek olarak ekle"}
                            name="isAttachment"
                            checked={fp.values?.isAttachment}
                            onChange={fp.handleChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="right">
                    <Grid item md={4}>
                        <Button
                            customType="mailSend"
                            color="primary"
                            loading={exportMailState.isLoading}
                            onClick={fp.submitForm}>Gönder</Button>
                    </Grid>
                    <Grid item md={4}>
                        <Button
                            customType="close"
                            onClick={(e) => {
                                dispatch(KararDestekSlice.actions.setState({
                                    ...kararDestek,
                                    mailOpen: false
                                }))
                            }}>Kapat</Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog >
    )
}
export default ButtonPrintMail;